import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_shipping_containers_to_verify_grid_ComponentContextService } from './FootprintManager.shipping_containers_to_verify_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


interface IFootprintManager_shipping_containers_to_verify_gridComponentEntity {
  Id?: number, LookupCode?: string, Notes?: string, ShippingDate?: string, Shipment?: { ActualWarehouseId?: number, ExpectedDate?: string, Carrier?: { Name?: string }, CarrierServiceType?: { Name?: string }, OrderLookups?: { CreatedSysDateTime?: string, Order?: { Id?: number, LookupCode?: string, OwnerReference?: string, RequestedDeliveryDate?: string, PreferredCarrier?: { Name?: string }, PreferredCarrierServiceType?: { Name?: string }, Project?: { Id?: number, LookupCode?: string, Owner?: { LookupCode?: string } } } }[] }, ContainerType?: { Name?: string }, LicensePlates?: { Id?: number, Location?: { Id?: number, Name?: string } }[]}

interface IFootprintManager_shipping_containers_to_verify_gridComponentInParams {
  warehouseId: number, locationId?: number, shippingContainerCode?: string, isFailed: boolean}


class FootprintManager_shipping_containers_to_verify_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_shipping_containers_to_verify_gridComponent;
  entity: IFootprintManager_shipping_containers_to_verify_gridComponentEntity;

  vars: { scannedValues?: { scannedValue?: string, materialId?: number, serialNumberId?: number, isVerified?: boolean, reasons?: string[] }[], isSelected?: boolean } = { };


 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    lookupcode: null,
    fail_reason: null,
    order_lookupcode: null,
    Owner_LookupCode: null,
    Project_LookupCode: null,
    Order_OwnerReference: null,
    carrier_name: null,
    CarrierServiceType_Name: null,
    shipping_date: null,
    Location_Name: null,
    Notes: null,
  }



  constructor(
    grid: FootprintManager_shipping_containers_to_verify_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_shipping_containers_to_verify_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.lookupcode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.lookupcode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.fail_reason = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.fail_reason,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.order_lookupcode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.order_lookupcode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Owner_LookupCode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Owner_LookupCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Project_LookupCode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Project_LookupCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Order_OwnerReference = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Order_OwnerReference,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.carrier_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.carrier_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.CarrierServiceType_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CarrierServiceType_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.shipping_date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.shipping_date,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Location_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Location_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Notes = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Notes,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_shipping_containers_to_verify_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_shipping_containers_to_verify_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      warehouseId:  $grid.inParams.warehouseId ,
      ownerId:  null ,
      projectId:  null ,
      shippingDate:  null ,
      shippingContainerCode:  null ,
      fullTextSearch:  $grid.fullTextSearch ,
      isFailed:  $grid.inParams.isFailed ,
    };
    const data = await this.$datasources.PackVerification.ds_shippingcontainers_to_verify_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_shipping_containers_to_verify_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.lookupcode.displayControl as TextModel).text = $row.entity.LookupCode;
    (this.cells.order_lookupcode.displayControl as TextModel).text = $row.entity.Shipment?.OrderLookups[0]?.Order?.LookupCode;
    (this.cells.Owner_LookupCode.displayControl as TextModel).text = $row.entity.Shipment?.OrderLookups[0]?.Order?.Project?.Owner?.LookupCode;
    (this.cells.Project_LookupCode.displayControl as TextModel).text = $row.entity.Shipment?.OrderLookups[0]?.Order?.Project?.LookupCode;
    (this.cells.Order_OwnerReference.displayControl as TextModel).text = $row.entity.Shipment?.OrderLookups[0]?.Order?.OwnerReference;
    (this.cells.carrier_name.displayControl as TextModel).text = $row.entity.Shipment?.Carrier?.Name;
    (this.cells.CarrierServiceType_Name.displayControl as TextModel).text = $row.entity.Shipment?.CarrierServiceType?.Name;
    (this.cells.shipping_date.displayControl as TextModel).text = $row.entity.ShippingDate?.toString();
    (this.cells.Location_Name.displayControl as TextModel).text = $row.entity.LicensePlates[0]?.Location?.Name;
    (this.cells.Notes.displayControl as TextModel).text = $row.entity.Notes;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'lookupcode' : {
        this.on_container_code_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_container_code_clicked(event = null) {
    return this.on_container_code_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_container_code_clickedInternal(
    $row: FootprintManager_shipping_containers_to_verify_gridComponentRowModel,
  $grid: FootprintManager_shipping_containers_to_verify_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_containers_to_verify_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  await $shell.FootprintManager.openshipping_container_editorDialog({ shippingContainerId: $row.entity.Id}, 'flyout', EModalSize.Xlarge);
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_shipping_containers_to_verify_gridComponentRowModel,
  $grid: FootprintManager_shipping_containers_to_verify_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_containers_to_verify_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $row.vars.isSelected = false;
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootprintManager-shipping_containers_to_verify_grid',
  templateUrl: './FootprintManager.shipping_containers_to_verify_grid.component.html'
})
export class FootprintManager_shipping_containers_to_verify_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_shipping_containers_to_verify_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('headersWidth', null);

  fullTextSearch: string;

  inParams: IFootprintManager_shipping_containers_to_verify_gridComponentInParams = { warehouseId: null, locationId: null, shippingContainerCode: null, isFailed: null };


  //#region Variables
  vars: { completedInstructionIds?: number[], isInitialized?: boolean, suppressFlows?: boolean } = { };
  //#endregion
  //#region Events
  @Output()
  refocus = new EventEmitter<void>();
  
  events = {
    refocus: this.refocus,
  }
  //#endregion

  headers = {
     lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'lookupcode', 'Container', false, false, null, false),       fail_reason: new GridHeaderModel(new HeaderStyles(null, null), 'fail_reason', 'Fail reason', false, false, null, false),       order_lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'order_lookupcode', 'Order', false, false, null, false),       Owner_LookupCode: new GridHeaderModel(new HeaderStyles(null, null), 'Owner_LookupCode', 'Customer', false, false, null, false),       Project_LookupCode: new GridHeaderModel(new HeaderStyles(null, null), 'Project_LookupCode', 'Project', false, false, null, false),       Order_OwnerReference: new GridHeaderModel(new HeaderStyles(null, null), 'Order_OwnerReference', 'PO/Ref. number', false, false, null, false),       carrier_name: new GridHeaderModel(new HeaderStyles(null, null), 'carrier_name', 'Carrier', false, false, null, false),       CarrierServiceType_Name: new GridHeaderModel(new HeaderStyles(null, null), 'CarrierServiceType_Name', 'Service type', false, false, null, false),       shipping_date: new GridHeaderModel(new HeaderStyles(null, null), 'shipping_date', 'Shipping date', false, false, null, false),       Location_Name: new GridHeaderModel(new HeaderStyles(null, null), 'Location_Name', 'Location', false, false, null, false),       Notes: new GridHeaderModel(new HeaderStyles(null, null), 'Notes', 'Notes', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_shipping_containers_to_verify_gridComponentRowModel[] = [];

  @Input('warehouseId') set $inParams_warehouseId(value: any) {
    this.inParams['warehouseId'] = value;
  }
  get $inParams_warehouseId(): any {
    return this.inParams['warehouseId'] ;
  }
  @Input('locationId') set $inParams_locationId(value: any) {
    this.inParams['locationId'] = value;
  }
  get $inParams_locationId(): any {
    return this.inParams['locationId'] ;
  }
  @Input('shippingContainerCode') set $inParams_shippingContainerCode(value: any) {
    this.inParams['shippingContainerCode'] = value;
  }
  get $inParams_shippingContainerCode(): any {
    return this.inParams['shippingContainerCode'] ;
  }
  @Input('isFailed') set $inParams_isFailed(value: any) {
    this.inParams['isFailed'] = value;
  }
  get $inParams_isFailed(): any {
    return this.inParams['isFailed'] ;
  }

  topToolbar = {
      start_verification: new ToolModel(new ButtonModel('start_verification', new ButtonStyles(null, null), false, false, false, 'Start verification', 'icon-ic_fluent_play_20_regular', null)
    , false)
  };

  bottomToolbar = {
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_shipping_containers_to_verify_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Containers to verify';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.warehouseId)) {
        this.$missingRequiredInParams.push('warehouseId');
      }
      if(isNil(this.inParams.isFailed)) {
        this.$missingRequiredInParams.push('isFailed');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 20;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      warehouseId:  $grid.inParams.warehouseId ,
      ownerId:  null ,
      projectId:  null ,
      shippingDate:  null ,
      shippingContainerCode:  null ,
      fullTextSearch:  $grid.fullTextSearch ,
      isFailed:  $grid.inParams.isFailed ,
    };
    try {
      const data = await this.$datasources.PackVerification.ds_shippingcontainers_to_verify_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_shipping_containers_to_verify_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_shipping_containers_to_verify_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_shipping_containers_to_verify_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_shipping_containers_to_verify_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_containers_to_verify_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $grid.vars.isInitialized = false;
  $grid.vars.completedInstructionIds = [];
  $grid.vars.suppressFlows = false;
  }
  on_start_verification_clicked(event = null) {
    return this.on_start_verification_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_start_verification_clickedInternal(
    $grid: FootprintManager_shipping_containers_to_verify_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_containers_to_verify_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  let errorTitle = 'Cannot verify shipping container';
  
  try {
      if ($grid.selectedRows.length === 1) {
          let row = $grid.selectedRows[0];
  
          if (!$utils.isDefined($grid.inParams.locationId)) {
              await $shell.FootprintManager.openErrorDialog('Verification location required', 'Please select a verification location before performing pack verification')
              return;
          }
          let targetLocation = $grid.inParams.locationId ?? row.entity.LicensePlates[0].Location.Id;
  
          let locationValidation = (await $flows.PackVerification.is_pack_verification_location_valid_flow({
              shippingContainerId: row.entity.Id,
              locationId: targetLocation
          }));
  
          if ($utils.isDefined(locationValidation.reasons)) {
              errorTitle = locationValidation.fail_description ?? 'Location is not valid';
              throw new Error((await $flows.Utilities.grammar_format_string_array_flow({ values: locationValidation.reasons })).formattedValue);
          }
  
          let startTasks = (await $datasources.PackVerification.ds_get_start_pack_verification_tasks_by_shippingContainerId.getList({ shippingContainerId: row.entity.Id })).result;
  
          let start_task: number;
  
          if ($utils.isDefined(startTasks)) {
              startTasks = startTasks.sort((a, b) => a.Id - b.Id) //Sort ascending
              start_task = startTasks.find(t => t.Status.Id === 1)?.Id;
          }
  
          await $shell.FootprintManager.openpack_verification_wizardDialog({
              shippingContainerId: row.entity.Id,
              startVerificationTaskId: start_task,
              targetLocationId: targetLocation,
              isBlind: !$grid.inParams.isFailed
          });
  
          await $grid.refresh();
      }
  }
  catch (error) {
      let targetError = error;
  
      while ($utils.isDefined(targetError.error)) {
          targetError = targetError.error;
      }
  
      await $shell.FootprintManager.openErrorDialog(errorTitle, targetError.message);
  }
  
  $grid.events.refocus.emit();
  }
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: FootprintManager_shipping_containers_to_verify_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_containers_to_verify_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // REMOVED (TO REVIEW): BROKEN BY GAMMA UPDATE
  //if (!$grid.vars.suppressFlows) {
  //    $grid.vars.suppressFlows = true;
  //
  //    for (let row of $grid.rows) {
  //        if (row.selected) {
  //           if (row.vars.isSelected) {
  //                row.selected = false;
  //                row.vars.isSelected = false;
  //            }
  //            else {
  //                row.vars.isSelected = true;
  //            }
  //        }
  //        else {
  //            row.vars.isSelected = false;
  //        }
  //    }
  
  //    $grid.vars.suppressFlows = false;
  //}
  
  if ($grid.selectedRows.length === 1) {
      $grid.topToolbar.start_verification.control.readOnly = false;
  }
  else {
      $grid.topToolbar.start_verification.control.readOnly = true;
  }
  }
  on_data_loaded(event = null) {
    return this.on_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_data_loadedInternal(
    $grid: FootprintManager_shipping_containers_to_verify_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_shipping_containers_to_verify_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($grid.inParams.isFailed) {
      $grid.headers.fail_reason.hidden = false;
  
      let reasons = (await $datasources.PackVerification.ds_get_failed_verification_reasoncodes_by_shippingContainerIds.get({ shippingContainerIds: $grid.rows.map(row => row.entity.Id)})).result;
  
      $grid.rows.forEach(row => {
          let reason = reasons.find(r => r.Id === row.entity.Id)?.TasksForActualSourceShippingContainer[0]?.ReasonCode?.Name;
  
          if ($utils.isDefinedTrimmed(reason)) {
              row.cells.fail_reason.displayControl.text = reason;
          }
      });
  }
  else {
      $grid.headers.fail_reason.hidden = true;
  }
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
